<div class="dotted-ring-loader">
  <div class="ring"></div>
  <div class="loading-text">Loading...</div>
</div>